import { CustomPlotlineElement, ExtendedPlotline } from './index'

export default function MenuButton(plotline: ExtendedPlotline): CustomPlotlineElement {
    const chart = plotline.axis.chart
    const isInverted = chart.inverted
    const { id, onShowDetails, data } = plotline.options

    const x = isInverted ? plotline.linePath.end.x - 12 : plotline.linePath.start.x
    const y = isInverted ? plotline.linePath.start.y - 7.7 : plotline.linePath.end.y - 8

    const menuIcon = chart.renderer
        .label('<b>...</b>', x, y)
        .css({ color: 'white', fontSize: '21px', fontFamily: 'SourceSansPro-Bold' })
        .attr({
            align: 'center',
            fill: '#F89300',
            height: 15,
            width: 20,
            zIndex: 45, // make sure that it stays above the series
            padding: 1,
            r: 3,
            id: id + '-button',
            visibility: id !== 'placeholder' ? 'hidden' : 'visible',
            cursor: 'pointer'
        })
        .on('mouseover', function () {
            if (id !== 'placeholder') menuIcon.attr({ visibility: 'visible' })
        })
        .on('mouseout', function () {
            if (id !== 'placeholder') menuIcon.attr({ visibility: 'hidden' })
        })
        .on('click', function () {
            onShowDetails(data, {
                marker: this.marker,
                chartPlotBox: this.chartPlotBox,
                isInverted: isInverted
            })
        })
        .add() as CustomPlotlineElement & { text: Highcharts.SVGElement; element: any }

    // Adjust text to center
    menuIcon.text.attr({ y: 10, x: 2 })

    // Necessary for Form popup positioning
    menuIcon.element.chartPlotBox = chart.plotBox
    menuIcon.element.marker = plotline.linePath

    menuIcon.update = function (plotline: ExtendedPlotline, hide) {
        this.attr({
            x: isInverted ? plotline.linePath.end.x - 12 : plotline.linePath.start.x,
            y: isInverted ? plotline.linePath.start.y - 7.7 : plotline.linePath.end.y - 8,
            opacity: hide ? 0 : 1
        })

        this.element.chartPlotBox = plotline.axis.chart.plotBox
        this.element.marker = plotline.linePath

        return null
    }

    menuIcon.destroy = function (this: CustomPlotlineElement & { text: Highcharts.SVGElement; element: any }) {
        this.element.chartPlotBox = null
        this.element.marker = null
        this.update = () => null

        return Object.getPrototypeOf(this).destroy.call(this)
    }

    return menuIcon
}
